import type { Contact } from '../data/contactTypes';

export function contactDisplayName(c: Contact): string {
  if (c.preferredName?.trim()) return c.preferredName.trim();
  const first = c.legalFirstName?.trim() ?? '';
  const last = c.legalLastName?.trim() ?? '';
  return [first, last].filter(Boolean).join(' ') || '—';
}

export function contactDisplayEmail(c: Contact): string {
  if (c.emails?.length) return c.emails.filter(Boolean).join(', ');
  return '';
}

export function contactDisplayPhone(c: Contact): string {
  if (c.phones?.length) return c.phones.map((p) => p.value).filter(Boolean).join(', ');
  return '';
}
